/**
 * @Description: 用于存储耗材类别的多语言文言内容相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialCategoryLanguageModel,
  MaterialCategoryLanguageSearchModel,
  MaterialCategoryLanguagePageSearchModel,
  MaterialCategoryLanguageAddModel,
  MaterialCategoryLanguageUpdateModel,
  IdsModel
} from '@/model/product/MaterialCategoryLanguageModel'

const baseUrl = Route.product + '/materialCategoryLanguage'

/**
 * 搜索分页数据
 */
export const pageSearchMaterialCategoryLanguage = (param: MaterialCategoryLanguagePageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialCategoryLanguageModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterialCategoryLanguage = (param: MaterialCategoryLanguageSearchModel) => {
  return https().request<RootObject<MaterialCategoryLanguageModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterialCategoryLanguage = (id: number) => {
  return https().request<RootObject<MaterialCategoryLanguageModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterialCategoryLanguage = (param: MaterialCategoryLanguageAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateMaterialCategoryLanguage = (param: MaterialCategoryLanguageUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeMaterialCategoryLanguage = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterialCategoryLanguage = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
